import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_26c5057c from 'nuxt_plugin_plugin_26c5057c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_3d240187 from 'nuxt_plugin_bootstrapvue_3d240187' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_20d4ff6c from 'nuxt_plugin_plugin_20d4ff6c' // Source: ./nuxt-perfect-cache-mow/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_c441c472 from 'nuxt_plugin_recaptcha_c441c472' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_6503cb5e from 'nuxt_plugin_vuesocialsharingplugin_6503cb5e' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_aa582af6 from 'nuxt_plugin_dayjsplugin_aa582af6' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_d3c80952 from 'nuxt_plugin_router_d3c80952' // Source: ./router.js (mode: 'all')
import nuxt_plugin_axiosaccessor_73d1553b from 'nuxt_plugin_axiosaccessor_73d1553b' // Source: ../plugins/axios-accessor.ts (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_scrollontop_4accebe2 from 'nuxt_plugin_scrollontop_4accebe2' // Source: ../plugins/scrollontop.js (mode: 'client')
import nuxt_plugin_visibility_eecf879e from 'nuxt_plugin_visibility_eecf879e' // Source: ../plugins/visibility.js (mode: 'client')
import nuxt_plugin_currency_51f1645c from 'nuxt_plugin_currency_51f1645c' // Source: ../plugins/currency.js (mode: 'all')
import nuxt_plugin_date_989c19d6 from 'nuxt_plugin_date_989c19d6' // Source: ../plugins/date.js (mode: 'all')
import nuxt_plugin_capitalize_06b55a17 from 'nuxt_plugin_capitalize_06b55a17' // Source: ../plugins/capitalize.js (mode: 'all')
import nuxt_plugin_vuerouterfix_0643750b from 'nuxt_plugin_vuerouterfix_0643750b' // Source: ../plugins/vue_router_fix.js (mode: 'all')
import nuxt_plugin_errorHandler_0620ac16 from 'nuxt_plugin_errorHandler_0620ac16' // Source: ../plugins/errorHandler (mode: 'all')
import nuxt_plugin_clickdisabled_610e3d32 from 'nuxt_plugin_clickdisabled_610e3d32' // Source: ../plugins/clickdisabled.js (mode: 'client')
import nuxt_plugin_gtag_71c5e2d0 from 'nuxt_plugin_gtag_71c5e2d0' // Source: ../plugins/gtag.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"charset","charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"theme-color","name":"theme-color","content":"#FFFFFF"},{"hid":"http-equiv","http-equiv":"Cache-control","content":"no-cache, no-store, must-revalidate"},{"hid":"Pragma","Pragma":"Cache-control","content":"no-cache"},{"hid":"lang","lang":"it"},{"hid":"language","lang":"Italian"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:locale","property":"og:locale","content":"it"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#233760"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_26c5057c === 'function') {
    await nuxt_plugin_plugin_26c5057c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_3d240187 === 'function') {
    await nuxt_plugin_bootstrapvue_3d240187(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_20d4ff6c === 'function') {
    await nuxt_plugin_plugin_20d4ff6c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_c441c472 === 'function') {
    await nuxt_plugin_recaptcha_c441c472(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6503cb5e === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6503cb5e(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_aa582af6 === 'function') {
    await nuxt_plugin_dayjsplugin_aa582af6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (typeof nuxt_plugin_router_d3c80952 === 'function') {
    await nuxt_plugin_router_d3c80952(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosaccessor_73d1553b === 'function') {
    await nuxt_plugin_axiosaccessor_73d1553b(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollontop_4accebe2 === 'function') {
    await nuxt_plugin_scrollontop_4accebe2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_visibility_eecf879e === 'function') {
    await nuxt_plugin_visibility_eecf879e(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_51f1645c === 'function') {
    await nuxt_plugin_currency_51f1645c(app.context, inject)
  }

  if (typeof nuxt_plugin_date_989c19d6 === 'function') {
    await nuxt_plugin_date_989c19d6(app.context, inject)
  }

  if (typeof nuxt_plugin_capitalize_06b55a17 === 'function') {
    await nuxt_plugin_capitalize_06b55a17(app.context, inject)
  }

  if (typeof nuxt_plugin_vuerouterfix_0643750b === 'function') {
    await nuxt_plugin_vuerouterfix_0643750b(app.context, inject)
  }

  if (typeof nuxt_plugin_errorHandler_0620ac16 === 'function') {
    await nuxt_plugin_errorHandler_0620ac16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickdisabled_610e3d32 === 'function') {
    await nuxt_plugin_clickdisabled_610e3d32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_71c5e2d0 === 'function') {
    await nuxt_plugin_gtag_71c5e2d0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
